<div class="ui-modal add-vehicle-to-group-dialog">
  <div class="header flex-row space-between-center">
    <div>{{ 'VEHICLE_GROUPS.ADD_VEHICLES_DIALOG.TITLE' | translate: { name: data.groupName } }}</div>
    <span class="ui-icon-close c-p" tabindex="0" role="button" (click)="onClose()" (keydown.enter)="onClose()"></span>
  </div>

  <div class="body flex-col flex-1 min-h-0 gap-16">
    <div class="dialog-tabs flex-row space-between-center">
      <app-database-tabs
        [tabs]="dialogTabs"
        [activeTab]="currentTab()"
        (activeTabChange)="changeActiveTab($event)"
      ></app-database-tabs>
      <ui-button
        type="secondary"
        iconClass="ui-icon-plus"
        [matTooltip]="'ADD_VEHICLE_MANUAL_MODAL.ADD_MANUALLY' | translate"
        (clickAction)="createVehicle()"
      ></ui-button>
    </div>
    @if ((currentTab() === tabs.ExistingVehicles && savedVehiclesViewState() !== viewState.INITIAL_EMPTY) ||
    (currentTab() === tabs.UnsavedVehicles && unsavedVehiclesViewState() !== viewState.INITIAL_EMPTY)) {
      <ui-search
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
        [placeholder]="searchPlaceholderKey() | translate"
      ></ui-search>
    }

    <div class="dialog-content flex-col min-h-0">
      @switch (currentTab()) {
        @case (tabs.ExistingVehicles) {
          @if (isVehiclesLoading()) {
            <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
          } @else {
            @switch (savedVehiclesViewState()) {
              @case (viewState.HAS_CONTENT) {
                <app-vehicles-table
                  #existingVehiclesTable
                  [vehicles]="filteredSavedVehicles()"
                  [canEdit]="false"
                  [checkboxEnabled]="true"
                  [isRowDisabled]="isSavedVehicleRowDisabled"
                  (selectionChange)="onSavedVehiclesSelectionChange($event)"
                ></app-vehicles-table>
              }
              @case (viewState.NO_RESULTS) {
                <ui-no-data
                  [imgSrc]="vehicleNoData.noResults.imgSrc"
                  [title]="vehicleNoData.noResults.title1 | translate"
                ></ui-no-data>
              }
              @case (viewState.INITIAL_EMPTY) {
                <ui-no-data
                  [imgSrc]="vehicleNoData.noSaved.imgSrc"
                  [title]="vehicleNoData.noSaved.title1 | translate"
                ></ui-no-data>
              }
            }
          }
        }
        @case (tabs.UnsavedVehicles) {
          @if (isVehiclesLoading()) {
            <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
          } @else {
            @switch (unsavedVehiclesViewState()) {
              @case (viewState.HAS_CONTENT) {
                <app-unsaved-vehicles-table
                  [unsavedVehicles]="filteredUnsavedVehicles()"
                  [selectable]="true"
                  (selectionChange)="onUnsavedVehiclesSelectionChange($event)"
                ></app-unsaved-vehicles-table>
              }
              @case (viewState.NO_RESULTS) {
                <ui-no-data
                  [imgSrc]="vehicleNoData.noResults.imgSrc"
                  [title]="vehicleNoData.noResults.title2 | translate"
                ></ui-no-data>
              }
              @case (viewState.INITIAL_EMPTY) {
                <ui-no-data
                  [imgSrc]="vehicleNoData.noSaved.imgSrc"
                  [title]="vehicleNoData.noSaved.title2 | translate"
                ></ui-no-data>
              }
            }
          }
        }
      }
    </div>
  </div>

  <div class="footer flex-row space-between-center">
    <span class="add-vehicle-to-group-dialog-selection">
      @if (selectedItemsCount() > 0) {
        {{ 'VEHICLE_GROUPS.ADD_VEHICLES_DIALOG.SELECTED_COUNT' | translate: { count: selectedItemsCount() } }}
      } @else {
        {{ 'VEHICLE_GROUPS.ADD_VEHICLES_DIALOG.NO_ITEMS_SELECTED' | translate }}
      }
    </span>
    <div class="flex-row gap-8">
      <ui-button type="secondary" [text]="'COMMON.CANCEL' | translate" (clickAction)="onClose()"></ui-button>
      <ui-button
        type="primary"
        [disabled]="addSelectedDisabled()"
        [loading]="isAddingVehiclesToGroups()"
        [text]="'VEHICLE_GROUPS.ADD_VEHICLES_DIALOG.ADD_SELECTED' | translate"
        (clickAction)="onAddSelected()">
      </ui-button>
    </div>
  </div>
</div>
